import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="container flex min-h-[60vh] flex-col items-center justify-center text-center">
      <h1 className="mb-4 text-6xl font-bold text-gray-900">404</h1>
      <h2 className="mb-4 text-2xl font-semibold text-gray-700">Page Not Found</h2>
      <p className="mb-8 text-gray-600">
        Sorry, the page you are looking for doesn't exist or has been moved.
      </p>
      <Link to="/">
        <button className="btn-primary px-6 py-3">Go Back Home</button>
      </Link>
    </div>
  );
}
